import { Switch } from "../Switch";
export const Toggle = Switch;
// export interface Toggle extends SwitchProps {}
